'use client'
import { gtmFromRedirectedToCompany } from '@/app/[lng]/components/GTMTrackers/GTMCompanyTracker'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import { Phone } from '@/app/types/memberType'
// import StarRating from '@/components/starRating'
import { Button } from '@/components/ui/button'
import { companyProfileRedirection } from '@/lib/redirectionUtils'
import Image from 'next/image'
import Link from 'next/link'
import { useParams } from 'next/navigation'
import { useSelector } from 'react-redux'

const OfferContact = () => {
  const { t } = useTranslation()
  const { offer } = useSelector((state: RootState) => state.offerData)
  const params = useParams()

  return (
    <div className="pt-4 ">
      <div className="flex gap-5 p-8 mobile:flex-col">
        <div className="flex flex-col gap-5">
          <div className="w-36 h-36 rounded-sm shadow-sm">
            <Image
              loading="lazy"
              width={500}
              height={500}
              src={
                offer?.offer?.company?.company_image
                  ? offer?.offer?.company?.company_image
                  : '/assets/Icons/noImage/noImage2.svg'
              }
              className={`rounded-sm w-full h-full ${offer?.offer?.company?.company_image ? 'object-contain' : 'object-cover'}`}
              alt="company-img"
            />
          </div>
          <Link
            href={companyProfileRedirection(
              offer?.offer?.company?.industry.name,
              offer?.offer?.company?.friendly_url,
              String(params?.lng) ?? 'en'
            )}
            onClick={() => {
              gtmFromRedirectedToCompany(
                'sales_offer_detail',
                offer?.offer?.company?.friendly_url,
                offer?.offer?.company?.id
              )
            }}
          >
            <Button variant="secondary" size="sx">
              {t('VIEW PROFILE')}
            </Button>
          </Link>
        </div>
        <div className="text-sm">
          <h1 className="font-ns_bold text-lg">
            {offer?.offer?.company?.name}{' '}
            {offer?.offer?.origin ? `- ${offer?.offer?.origin.name}` : ''}
          </h1>
          <p className="max-w-[500px] text-primary-foreground font-light">
            {offer?.offer?.company?.company_addresses &&
              offer?.offer?.company?.company_addresses.street_address}
          </p>
          <div className="py-3 mobile:py-1">
            {offer?.offer?.origin && (
              <span className="max-w-max flex gap-1 text-sm border bg-light_gray border-gray_border rounded-full  px-2">
                <Image
                  loading="lazy"
                  width={10}
                  height={10}
                  src={'/assets/Icons/globe.svg'}
                  alt="icon"
                />
                {offer?.offer?.origin.name}
              </span>
            )}
          </div>
          <div className="flex flex-col gap-1 mt-2.5 font-ns_bold text-sm pb-4 mobile:mt-1 mobile:pb-1">
            <p className="font-ns_bold">
              {t('Activities')}:{' '}
              <span className="font-light text-primary-foreground">
                {offer?.offer?.company?.activities
                  ? offer?.offer?.company?.activities
                      .map((item: any) => item.name)
                      ?.join(', ')
                  : t('NA')}
              </span>
            </p>
            <p className="font-ns_bold">
              {t('Products')}:{' '}
              <span className="font-light text-primary-foreground">
                {offer?.offer?.company?.products?.length > 0
                  ? offer?.offer?.company?.products.map(
                      (item: string, index: number) => (
                        <span key={index}>
                          {item}
                          {index < offer?.offer?.company?.products.length - 1 &&
                            ', '}
                        </span>
                      )
                    )
                  : 'No Products'}
              </span>
            </p>
          </div>
          {offer?.offer?.companycompany_url && (
            <p className="font-ns_bold">
              {t('Website')}:{' '}
              <span className="font-light text-light_black">
                {offer?.offer?.companycompany_url}
              </span>
            </p>
          )}
          <div className="flex flex-col gap-2 mt-2 mobile:mt-0">
            <p className="font-ns_bold flex flex-col gap-1">
              {`${offer?.contact?.contact?.title ?? ''} ${offer?.contact?.contact?.first_name ?? ''} ${offer?.contact?.contact?.last_name ?? ''}`}
              <span className=" text-grey_forty text-xs flex gap-0.5">
                {offer?.contact?.contact?.department?.name ?? ''}
                <span>
                  {offer?.contact?.contact?.position
                    ? `${offer?.contact?.contact?.department?.name ? ' -' : ''} ${offer?.contact?.contact?.position}`
                    : ''}
                </span>
              </span>
            </p>

            <div className="flex gap-2">
              {offer?.offer?.company?.speaks?.length > 0 && (
                <>
                  <Image
                    loading="lazy"
                    src="/assets/Icons/speakIcon.svg"
                    width={13}
                    height={12}
                    alt="speak"
                    className=" mr-3"
                  />
                  {t('Speak')}:{' '}
                  <p className="flex gap-0.5 text-primary-foreground">
                    {offer?.offer?.company?.speaks?.join(', ')}
                  </p>
                </>
              )}
            </div>
            <div className="flex gap-2">
              {offer?.contact?.phones && (
                <>
                  <Image
                    loading="lazy"
                    src="/assets/Icons/phoneIcon.svg"
                    width={13}
                    height={12}
                    alt="speak"
                    className=" mr-3"
                  />
                  {t('Contacts')}:{' '}
                  <p className="text-primary-foreground capitalize">
                    {offer?.contact?.phones?.length > 0
                      ? offer?.contact?.phones
                          ?.map(
                            (item: Phone) =>
                              `${t(item?.contact_type) ?? ''} : ${item?.code?.dial_code ?? ' -'} ${item?.contact ?? ''}`
                          )
                          .join(', ')
                      : t('Contact not available')}
                  </p>
                </>
              )}
            </div>
            <div className="flex gap-2">
              {offer?.contact?.contact?.email && (
                <>
                  <Image
                    loading="lazy"
                    src="/assets/Icons/mailIcon.svg"
                    width={13}
                    height={12}
                    alt="speak"
                    className=" mr-3"
                  />
                  {t('E-mail')}:{' '}
                  <div className="text-primary-foreground">
                    {offer?.contact?.contact?.email}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OfferContact
